import type { ConfigData, DeliveryReconSiteOverviewRow } from './types'

export function isCustomConfig(
  row: DeliveryReconSiteOverviewRow | null,
  configKey: 'match' | 'approve',
  configData: ConfigData | undefined
): boolean {
  if (!row || !configData) return false
  // Curse Matthew Anderson for making me do this 💢
  const configDataPrefix = configKey === 'match' ? 'link' : configKey
  return (
    row[`delivery_${configKey}_hour_threshold`] !== configData[`${configDataPrefix}_hour_threshold`] ||
    row[`delivery_${configKey}_volume_threshold`] !== configData[`${configDataPrefix}_volume_threshold`]
  )
}

export function getInitialConfigValues(
  row?: DeliveryReconSiteOverviewRow | null,
  configData?: ConfigData | null
): Partial<DeliveryReconSiteOverviewRow> {
  return {
    delivery_approve_hour_threshold:
      row?.delivery_approve_hour_threshold ?? configData?.approve_hour_threshold ?? undefined,
    delivery_approve_volume_threshold:
      row?.delivery_approve_volume_threshold ?? configData?.approve_volume_threshold ?? undefined,
    delivery_match_hour_threshold: row?.delivery_match_hour_threshold ?? configData?.link_hour_threshold ?? undefined,
    delivery_match_volume_threshold:
      row?.delivery_match_volume_threshold ?? configData?.link_volume_threshold ?? undefined,
  }
}
